import moment from "moment";
import { XOR } from "ts-xor";

import { makePaginatedSearchWithCount } from "api/makeApiRequestType/makePaginatedSearchWithCount";
import { formatDataForGetRequest } from "api/utils/formatDataForGetRequest";
import { ValidationCallback } from "validation/validate";
import { formatDateForApi } from "api/utils/formatDateForApi";

interface BaseParams {
	cursor?: Date;
	cursorType?: "after" | "before";
}

interface ParamsWithUid extends BaseParams {
	uid: string;
}

interface ParamsWithContactUid extends BaseParams {
	contactUid: string;
}

type Params = XOR<ParamsWithUid, ParamsWithContactUid> & {
	contactType?: string;
};

interface RawApiOutputRow {
	uid: string;
	displayNameUser: string;
	contactUid: string;
	displayNameContact: string;
	contactType: string;
	dateOfLastActivityUTC: string;
}

export interface OutputRow
	extends Omit<RawApiOutputRow, "dateOfLastActivityUTC"> {
	dateOfLastActivityUTC: Date;
}

const flagValidationErrorsInRow: ValidationCallback<RawApiOutputRow> = (
	input,
	{ checkField }
) => {
	checkField("uid", { type: "string" });
	checkField("displayNameUser", { type: "string" });
	checkField("contactUid", { type: "string" });
	checkField("displayNameContact", { type: "string" });
	checkField("contactType", { type: "string" });
	checkField("dateOfLastActivityUTC", { type: "datestring" });
};

export const getContacts = makePaginatedSearchWithCount<
	Params,
	RawApiOutputRow,
	OutputRow
>({
	endPoint: "contacts",
	flagValidationErrorsInRow: flagValidationErrorsInRow,
	preProcessor: ({
		uid,
		contactUid,
		contactType,
		cursor,
		cursorType = "after"
	}: Params) =>
		formatDataForGetRequest({
			uid,
			contactUid,
			contactType,
			cursorType,
			...(cursor ? { cursor: formatDateForApi(cursor) } : {})
		}),
	postProcessor: importRow
});

function importRow({
	dateOfLastActivityUTC,
	...rest
}: RawApiOutputRow): OutputRow {
	return {
		...rest,
		dateOfLastActivityUTC: moment.utc(dateOfLastActivityUTC).toDate()
	};
}
